module.exports = __webpack_public_path__ + "static/media/bottom_banner_3_2.ab1b048e.png";